/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=95929b04&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=95929b04&lang=css&scoped=true"

import exportComponent from "/root/workspace/company_D7jw/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95929b04"]])

export default __exports__